var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"btn btn-outline-primary",attrs:{"to":_vm.to}},[_vm._v("Edit")])
}
var staticRenderFns = []

export { render, staticRenderFns }